'use strict';

angular.module('shiftTraderApp')
  .directive('saShiftTradeLineItem', function () {
    return {
      templateUrl: 'views/directives/saShiftTradeLineItem.html',
      restrict: 'A',
      scope: {
        trade:'=shiftTrade',
        me:'=loggedInUser'
      },
      controller: ['$scope', '$state', function($scope, $state) {
        $scope.test = '';

        $scope.goToPage = function() {
          $scope.trade._highlight = true;
          $state.go('trades.show', {tradeId: $scope.trade.id});
        };
      }]
    };
  });
